import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import RouterPage from "./router/RouterPage";
import { GlobalStyle } from "./globalStyle/GlobalStyle";
import { AppProvider } from "./context/AppContext";

function App() {
	return (
		<>
			<GlobalStyle />
			<AppProvider>
				<RouterPage />
			</AppProvider>
			<ToastContainer />
		</>
	);
}

export default App;
